import React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import HeaderComponent from "./header";
import TabSegment from "../TabSegment";
import Helpers from "../../../helpers";
import "./entityViewer.scss";

class EntityViewer extends React.Component {
  constructor(props) {
    super(props);
    this.core = this.props.core;
    this.helper = this.core.make("oxzion/restClient");
    this.alertAdapter = this.core?.make("oxzion/alert");
    this.edit = this.props.edit;
    this.fileId = this.props.fileId,
      this.state = {
        entityConfig: null,
        fileData: this.props.fileData,
        dataReady: false,
        tabs: [],
        selectedTab: this.props.proc.args.selectedTab ?? "",
        entityActions: [],
        showEditOption: false,
        editFormContent: {},
      };
  }

  stepDownPage() {
    let stepDownPage = new CustomEvent("stepDownPage", {
      detail: {},
      bubbles: true,
    });

    if (document.getElementById("navigation_" + this.props.appId)) {
      document.getElementById("navigation_" + this.props.appId).dispatchEvent(stepDownPage);
    }
  }

  handleEntityViewerRefresh = () => {
    this.setState({ dataReady: false }, () => {
      this.init(false);
    });
  };

  async init(entityRefresh = true) {
    const fileData = await this.getFileDetails();
    if (fileData) {
      this.fileId = fileData.uuid;

      if (entityRefresh) {
        const entityPage = await this.getEntityPage(fileData.entity_id);
        if (entityPage?.data) {
          this.setState({
            entityConfig: entityPage.data,
            fileData,
            tabs: this.constructTabs(entityPage.data),
            dataReady: true,
            editFormContent: this.prepareEditFormContent(entityPage.data, fileData),
            entityActions: this.prepareEntityActions(entityPage.data),
          });
        }
      } else {
        this.setState({ fileData, dataReady: true });
      }
    }
  }

  componentDidMount() {
    const customEvents = {
      handleEntityViewerRefresh: () => {
        this.handleEntityViewerRefresh();
      },
    };
    for (const key in customEvents) {
      document.getElementById("navigation_" + this.props.appId)?.addEventListener(key, customEvents[key], false);
    }
    this.init();
  }

  async getFileDetails() {
    const { appId, item } = this.props;
    const route = item?.assocDataRoute
      ? Helpers.ParameterHandler.replaceParams(appId, item.assocDataRoute, this.state.fileData)
      : `/app/${appId}/file/${this.fileId}/data`;

    const response = await this.helper.request("v1", route, {}, "get");

    if (response.status === "success" && response.data) {
      if (Array.isArray(response.data) && response.data.length === 0) {
        this.stepDownPage();
        this.alertAdapter?.show({title: "File does not exist", confirmButtonText: "Got it" });
      } else {
        const data = Array.isArray(response.data) ? response.data[0] : response.data;
        return { ...data?.data, ...data};
      }
    }
    else if (response.status === "error" && response.message) {
      this.stepDownPage();
      this.alertAdapter?.show({title: response.message, confirmButtonText: "Got it" });
    }

    return null;
  }

  async getEntityPage(entityId) {
    let fileContent = await this.helper.request("v1", "/app/" + this.props.appId + "/entity/" + entityId + "/page", {}, "get");
    return fileContent;
  }

  updatePageContent = (config) => {
    let eventDiv = document.getElementById("navigation_" + this.props.appId);
    let ev2 = new CustomEvent("addPage", {
      detail: config,
      bubbles: true,
    });
    eventDiv.dispatchEvent(ev2);
  };

  printToPDF = async () => {
    this.setState(
      { selectedTab: "Overview" },
      () => {
        setTimeout(() => {
          const appName = this.props.proc?.metadata?.name;
          const appWindow = document.querySelector(`[data-id="${appName}_Window"]`);
          // Prefer EntityViewer TabSegment content when present. Single-tab entities
          // (e.g. Form.io wizards) never render .active_tabstrip, so fall back to the
          // entity body / form root that is always in the DOM.
          const element =
            appWindow?.querySelector(".active_tabstrip") ||
            appWindow?.querySelector(".entity-viewer-content") ||
            appWindow?.querySelector(".form-render");

          if (!element) {
            this.props?.notif?.current?.notify("", "Nothing available to print", "error", undefined, 2000);
            return;
          }

          Helpers.DomElementPrinter.printElement(element);
        }, 300);
      }
    );
  };


  generateCopyLink = () => {
    this.props?.notif?.current?.notify("", "Link has been copied to clipboard", "success", undefined, 2000);
    this.core.make("oxzion/link").copyToClipboard(this.core.config("ui.url") + "?app=" + this.state.entityConfig.app_name + "&fileId=" + this.fileId);
  };

  prepareEntityActions = (entityConfig) => {
    let actions = [
      {
        label: "Copy link",
        value: "copylink",
        icon: "fa-solid fa-link",
      },
    ];
    if (entityConfig?.enable_print && entityConfig?.enable_view) {
      actions.push({
        label: "Print",
        value: "print",
        icon: "fa-solid fa-print",
      });
    }
    if (entityConfig?.enable_auditlog) {
      actions.push({
        label: "Audit Logs",
        value: "auditlogs",
        icon: "fa-solid fa-history",
      });
    }
    return actions;
  };

  prepareEditFormContent = (entityConfig, fileData) => {
    var row = fileData;
    var profile = OSjs.make("oxzion/profile").get().key;
    let paramsRule = (entityConfig?.edit_display_rule == null || entityConfig?.edit_display_rule?.trim().length == 0) || entityConfig?.edit_display_rule;
    let showEdit = eval(paramsRule);
    if (showEdit && entityConfig?.form_name && entityConfig?.form_uuid) {
      let formContent = {
        pageContent: [
          {
            type: "Form",
            form_id: entityConfig.form_uuid,
            name: entityConfig.form_name,
            fileId: this.fileId,
          },
        ],
        title: "Edit",
      };
      if (this.edit == 1) {
        this.updatePageContent(formContent);
        this.edit = 0;
      }
      this.setState({
        showEditOption: true,
      });

      return formContent;
    }
    return {};
  };

  uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  constructTabs(entityConfig) {
    var tabs = [];
    var that = this;
    var entityConfigContent = [];
    if (this.props?.item?.entityViewerForm || entityConfig?.view_as_form) {
      let formId = this.props.item.entityViewerForm ?? entityConfig.entity_viewer_form;
      const obj = {
        type: "Form",
        readOnly: true,
        form_id: formId,
        fileId: this.fileId,
      };
      entityConfigContent.push(obj);
    } else {
      if (entityConfig?.content?.length > 0) {
        entityConfig.content.map((item) => {
          item["fileId"] = that.fileId;
          entityConfigContent.push(item);
        })
      }
    }
    if (entityConfigContent && entityConfig?.enable_view) {
      tabs.push({
        name: "Overview",
        uuid: this.uuidv4(),
        content: entityConfigContent,
        className: "overview-tab-container",
      });
    }
    if (entityConfig?.enable_documents != "0") {
      tabs.push({
        name: "Attachments",
        uuid: this.uuidv4(),
        content: [{ type: "DocumentViewer", url: "file/" + this.props.fileId + "/attachment", entityConfig }],
      });
    }
    if (entityConfig?.enable_relation != "0") {
      let that = this;
      entityConfig?.relations_config?.map(function (key, index) {
        let columnConfiguration = [];
        entityConfig.relations_config[index].selectColumns.map(function (columns, colIndex) {
          columnConfiguration.push({
            title: columns.text,
            field: columns.name,
            filter: columns.data_type,
          });
        });
        tabs.push({
          name: entityConfig.relations_config[index].relationTabName,
          content: [
            {
              gridContent: {
                relation_name: entityConfig.relations_config[index].relationTabName,
                route: `file/${that.fileId}/filerelation/${entityConfig.relations_config[index].relationsRoute}`,
                relationsParentRoute: `${entityConfig.relations_config[index].addRelationRoute}`,
                parent_fileId: `${that.fileId}`,
                disableAppId: false,
                columnConfig: columnConfiguration,
                actions: [
                  {
                    name: "View",
                    icon: "fa fa-eye",
                    rule: "true",
                    defaultAction: false,
                    details: [
                      {
                        type: "EntityViewer",
                      },
                    ],
                    Name: "View",
                  },
                ],
                //   "operations": {
                //     "actions": [
                //         {
                //             "details": [
                //                 {
                //                     "type": "Form",
                //                     "formSource": "existingForm",
                //                     "form_id": "66a85750-ac48-48b0-88af-11ed8eeb36b3"
                //                 }
                //             ],
                //             "name": "Create",
                //             "icon": "fas fa-plus",
                //             "rule": "true"
                //         }
                //     ],
                //     "title": "Operation"
                // }
              },
              type: "List",
              appId: that.appId,
              fileId: that.fileId,
              core: that.core,
            },
          ],
          uuid: that.uuidv4(),
          isRelationTab: true,
        });
      });
    }
    return tabs;
  }

  selectAction = (event) => {
    if (event?.value) {
      switch (event.value?.value) {
        case "print":
          this.printToPDF();
          break;
        case "copylink":
          this.generateCopyLink();
          break;
        case "auditlogs":
          this.openAuditLogPage();
          break;
        default:
          break;
      }
    }
  };

  itemRender = (liElement, itemProps) => {
    const item = itemProps.dataItem;
    return (
      <div {...liElement.props} style={{ fontSize: "13px", color: "#212121", padding: "0.5rem 1.25rem", fontWeight: "400" }}>
        <i className={item.icon} style={{ marginRight: "8px" }}></i>
        <span>{item.label}</span>
      </div>
    );
  };

  openEditForm = () => {
    this.updatePageContent(this.state.editFormContent);
  };

  openAuditLogPage = () => {
    let pageContent = {
      pageContent: [
        {
          type: "History",
          appId: this.props.appId,
          core: this.core,
          fileId: this.fileId,
          disableControls: true,
        },
      ],
      title: "Audit Logs",
    };

    this.updatePageContent(pageContent);
  };

  openActivityWindow = () => {
    let pageContent = {
      pageContent: [
        {
          type: "Comment",
          appId: this.props.appId,
          core: this.core,
          fileId: this.fileId,
          disableControls: true,
        },
      ],
      popupConfig: true,
      title: "Activity",
      popupConfigRight: true,
    };

    this.updatePageContent(pageContent);
  };

  render() {
    return (
      this.state.dataReady &&
      <div className="entity-viewer-container">
        <div className="entity-viewer-header">
          <HeaderComponent
            entityDetails={this.state.entityConfig}
            appId={this.props.appId}
            fileId={this.fileId}
            core={this.core}
            fileData={this.state.fileData}
            pageId={this.uuidv4()}
            proc={this.props.proc}
            template={this.props.item?.headerTemplate}
          />
          <div className="entity-actions-container">
            {this.state.showEditOption && (
              <div className="entity-action-icon">
                <i className="fa-regular fa-pen" title="Edit" onClick={this.openEditForm}></i>
              </div>
            )}
            {this.state.entityActions.length > 0 && <div className="actions-dropdown">
              <DropDownList
                textField="label"
                dataItemKey="value"
                data={this.state.entityActions}
                onChange={this.selectAction}
                itemRender={this.itemRender} // Custom renderer for items
                value={{ label: "Actions", value: null, icon: "" }}
              />
            </div>
            }
            {this.state.entityConfig.enable_comments ? (
              <div className="entity-action-icon">
                <i className="fa-regular fa-message" title="Activity" onClick={this.openActivityWindow}></i>
              </div>
            ) : null}
          </div>
        </div>
        <div className="entity-viewer-content">
          <TabSegment
            appId={this.props.appId}
            notif={this.props.notif}
            core={this.core}
            proc={this.props.proc}
            fileId={this.fileId}
            tabs={this.state.tabs ?? []}
            pageId={this.uuidv4()}
            currentRow={this.state.fileData}
            selectedTab={this.state.selectedTab ?? ""}
            updateSelectedTab={(selected) => this.setState({ selectedTab: selected })}
          />
        </div>
      </div>
    )
  }
}

export default EntityViewer;
